import $ from 'jquery';
import modaal from 'modaal';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

$('.transcript-trigger').modaal({
	type: 'inline'
});

$('.learning-center-card[data-href]').on('click', (e) => {
    const target = e.currentTarget;
    const url = $(target).data('href');
    if (url.length > 0) {
        window.location = url;
    }
});

// $('.video-play-btn .video-trigger').modaal({
// 	type: 'video'
// });